<template>
  <div
    class="rmr-toggle-card"
    :class="{
      'rmr-toggle-card--active': value,
      'rmr-toggle-card--disabled': disabled,
      [`rmr-toggle-card--size-${size}`]: true,
    }"
    @click="onToggle"
  >
    <v-checkbox
      :input-value="value"
      :label="label"
      :disabled="disabled"
      dense
      hide-details
      class="rmr-checkbox mt-0 pt-0"
      @click.stop
      @change="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: "RmrToggleCard",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md"].includes(value),
    },
  },
  methods: {
    onToggle() {
      if (this.disabled) return;
      this.$emit("input", !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/ui/forms/_rmr-input.scss";
</style>

<style lang="scss" scoped>
.rmr-toggle-card {
  border: 1px solid $rmr-border;
  background: $rmr-surface-1;
  border-radius: $rmr-radius-2xl;
  padding: 10px 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(.rmr-toggle-card--active) {
    border-color: $rmr-border-hover;
    background: $rmr-surface-2;
  }

  &--active {
    background: rgba(99, 102, 241, 0.06);
    border-color: $rmr-indigo;
    box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.14);
  }

  &--disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  &--size-sm {
    border-radius: $rmr-radius-xl;
    padding: 8px 12px;
  }
}

.rmr-toggle-card--size-sm ::v-deep .v-input--checkbox {
  margin-top: 0 !important;
}

.rmr-toggle-card--size-sm ::v-deep .v-label {
  font-size: $rmr-fs-md;
  line-height: 1.35;
}
</style>
